import React from 'react';
import { Star, ArrowRight, Check, MessageSquare } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import Navbar from '../Navbar';
import Footer from '../Footer';
import { useAuth } from '../../context/AuthContext';

const GatheringFeedbackPage = () => {
  const { login } = useAuth();
  const features = ['Pesquisas automáticas', 'NPS automatizado', 'Análise de sentimento', 'Relatórios detalhados'];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-28 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 bg-yellow-100 text-yellow-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
                <Star className="h-4 w-4" />Feedback
              </div>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                Colete <span className="text-yellow-500">feedback</span> automaticamente
              </h1>
              <p className="text-xl text-gray-600 mb-8">Envie pesquisas de satisfação e colete avaliações dos clientes automaticamente.</p>
              <Button onClick={login} size="lg" className="bg-[#3b82f6] hover:bg-[#2563eb]">Começar gratuitamente</Button>
            </div>
            <div className="bg-yellow-50 rounded-3xl p-6">
              <div className="bg-white rounded-2xl p-6 text-center">
                <p className="font-semibold mb-4">Como foi sua experiência?</p>
                <div className="flex justify-center gap-2 mb-4">
                  {[1,2,3,4,5].map(n => (<button key={n} className="w-10 h-10 bg-yellow-100 hover:bg-yellow-400 rounded-full text-lg transition-colors">⭐</button>))}
                </div>
                <Button className="w-full bg-yellow-500 hover:bg-yellow-600 text-white">Enviar avaliação</Button>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-gray-50 py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Recursos</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {features.map((f) => (<div key={f} className="bg-white rounded-xl p-6 shadow-sm"><Check className="h-6 w-6 text-green-500 mb-3" /><p className="font-medium text-gray-900">{f}</p></div>))}
            </div>
          </div>
        </div>
        <div className="py-16"><div className="max-w-4xl mx-auto px-4"><Card className="bg-gradient-to-br from-[#3b82f6] to-[#1d4ed8] text-white"><CardContent className="py-12 text-center"><h2 className="text-2xl font-bold mb-4">Melhore com feedback real</h2><Button onClick={login} variant="secondary" size="lg" className="bg-white text-[#3b82f6] hover:bg-gray-100">Começar agora <ArrowRight className="ml-2 h-4 w-4" /></Button></CardContent></Card></div></div>
      </main>
      <Footer />
    </div>
  );
};
export default GatheringFeedbackPage;
